import * as styles from './TextBlock.module.css'

import React from 'react'

interface Props {
  children: React.ReactNode
}

const TextBlock: React.FC<Props> = (props) => {
  const { children } = props

  return <div className={styles.container}>{children}</div>
}

export default TextBlock
